import axios from "axios"


// can be used to grab the course hyperlink if the link is not already defined on mount (if the link is null, grabs)
// this takes in the current hyperlink, the mounted ref, the invalid ID func, and the setLink state func
export default async function getHyperlink(hyperlink, mounted, courseID, setInvalidID, setLink, linkName){

    // if the linkName is not defined, assumes looking for post test link
    const linkLoc = linkName || "postTestLink"

    // if the hyperlink is undefined, grab it
    if (hyperlink === null || hyperlink === "" || hyperlink === undefined) {
        let tempLink = null
        let tempInvalid = false

        // check if the courseID exists in the system
        console.log("Hyperlink not found, Getting hyperlink")
        const res = await axios.get('/api/course/' + courseID)

        // if the course exists, then set the hyperlink to the given one
        if (res.data.course) {
            tempLink = res.data.course[linkLoc]

            // check if the link is defined on the course thing
            if (tempLink === null || tempLink === "" || tempLink === undefined) tempInvalid = true

            // if it doesn't, then display an error
        } else tempInvalid = true

        if (mounted.current) {
            if (tempInvalid) setInvalidID(tempInvalid)
            setLink(tempLink)
        }
    }

    // input a time is the form of PT~H~M~S
    // not used, just going to take the difference between start and finish dates and use that instead of this weird format
    // export function convert2004Time(time){

    // }
}